const FAQS_AVERAGE_PRICE = {
  key: 'AVERAGE_PRICE',
  question: 'AVERAGE_PRICE_QUESTION',
  answer: 'AVERAGE_PRICE_ANSWER'
}
const FAQS_AVERAGE_KM = {
  key: 'AVERAGE_KM',
  question: 'AVERAGE_KM_QUESTION',
  answer: 'AVERAGE_KM_ANSWER'
}
const FAQS_POPULAR_YEAR = {
  key: 'POPULAR_YEAR',
  question: 'POPULAR_YEAR_QUESTION',
  answer: 'POPULAR_YEAR_ANSWER'
}
const FAQS_AVERAGE_CONSUMPTION = {
  key: 'AVERAGE_CONSUMPTION',
  question: 'AVERAGE_CONSUMPTION_QUESTION',
  answer: 'AVERAGE_CONSUMPTION_ANSWER'
}
const FAQS_POPULAR_FUEL_TYPE = {
  key: 'POPULAR_FUEL_TYPE',
  question: 'POPULAR_FUEL_TYPE_QUESTION',
  answer: 'POPULAR_FUEL_TYPE_ANSWER'
}
const FAQS_POPULAR_COLOR = {
  key: 'POPULAR_COLOR',
  question: 'POPULAR_COLOR_QUESTION',
  answer: 'POPULAR_COLOR_ANSWER'
}

const KEYS_WITH_THOUSANDS_SEPARATOR = ['AVERAGE_PRICE', 'AVERAGE_KM']

const SEARCH_FAQS = [
  FAQS_AVERAGE_PRICE,
  FAQS_AVERAGE_KM,
  FAQS_POPULAR_YEAR,
  FAQS_AVERAGE_CONSUMPTION,
  FAQS_POPULAR_FUEL_TYPE,
  FAQS_POPULAR_COLOR
]

export {SEARCH_FAQS as searchFaqsConfig, KEYS_WITH_THOUSANDS_SEPARATOR as keysWithThousandsSeparator}
